import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/components/Dashboard'
import BadGateway from '@/components/BadGateway'
import Students from '@/components/Students'
import Categories from '@/components/Categories'
import AddCategory from '@/components/AddCategory'
import EditCategory from '@/components/EditCategory'
import Login from '@/components/Login'
import AddDocument from '@/components/AddDocument'
import Documents from '@/components/Documents'
import Quizs from '@/components/Quizs'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/login',
            name: 'Login',
            props: { page: 5 },
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            props: { page: 1 },
            alias: '/',
            meta: { requiresAuthAdmin: true },

        },
        {
            path: '/students',
            name: 'Students',
            props: { page: 2 },
            component: Students,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/categories',
            name: 'Categories',
            props: { page: 2 },
            component: Categories,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-category',
            name: 'AddCategory',
            props: { page: 8 },
            component: AddCategory,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/edit-category/:categoryId',
            name: 'EditCategory',
            props: { page: 8 },
            component: EditCategory,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/404',
            name: 'BadGateway',
            props: { page: 5 },
            component: BadGateway,
        },
        {
            path: '*',
            props: { page: 5 },
            redirect: '/404'
        },
        {
            path: '/home',
            props: { page: 5 },
            redirect: '/dashboard',
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/documents',
            name: 'documents',
            props: { page: 3 },
            component: Documents,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/documents/:documentId/quizs/:title',
            name: 'Quizs',
            props: { page: 8 },
            component: Quizs,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-document',
            name: 'AddDocument',
            props: { page: 4 },
            component: AddDocument,
            meta: { requiresAuthAdmin: true },
        },
    ],

})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuthAdmin)) {
        if (!localStorage.getItem('fastAdminToken')) {
            next({
                name: "Login"
            })
        } else {
            next();
        }
    } else {
        next();
    }

    if (to.matched.some(record => record.meta.requiresAuthTeacher)) {
        if (!localStorage.getItem('fastTeacherToken')) {
            next({
                name: "LoginTeacher"
            })
        } else {
            next();
        }
    } else {
        next();
    }


})

export default router